var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('LaHeader',{attrs:{"msg":"深圳斗鲸科技"}}),_c('LaIntroduce'),_c('LaAdvantage'),_c('LaAdvertising'),_c('LaWinCooperation'),_c('LaCooperativeCustomers'),_c('Camera'),_c('LaunchPartner'),_c('LaBottomLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }